export default "__VITE_ASSET__BoOUVDnf__"